import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { acGetAllCompanies, acGetAccessKey } from '../../store/actions';
import { DataTable } from '../default';
import { CreateAccessCredentialsModal, UpdateAccessKeyModal } from '../modals';

/**
 * @description UserManagementTable function displays a table of access credentials.
 * The function fetches all access credentials from the server and renders them in a table format.
 * It also provides functionality to create and update access credentials.
 * 
 * @author Paulo Victor Borges
 * @returns {JSX.Element} The UserManagementTable component
 */
const UserManagementTable = () => {

    const dispatch = useDispatch()

    const [openCreateModal, setOpenCreateModal] = useState(false)
    const [openUpdateModal, setOpenUpdateModal] = useState(false)

    const allCredentials = useSelector(state => state.auth.allCredentials)
    const isLoadingAllCredentials = useSelector(state => state.auth.isLoadingAllCredentials)
    const hasErrorAllCredentials = useSelector(state => state.auth.hasErrorAllCredentials)

    const selectedKey = useSelector(state => state.accessCredentials?.selectedKey || null)
    const isCreatingKey = useSelector(state => state.accessCredentials?.isCreatingKey || false)
    const isUpdatingKey = useSelector(state => state.accessCredentials?.isUpdatingKey || false)

    useEffect(() => {
        dispatch(acGetAllCompanies())
            .catch(error => console.error(error))
        // eslint-disable-next-line
    }, [])

    const columns = [
        {
            accessorKey: 'company_id',
            header: 'ID da Empresa'
        },
        {
            accessorKey: 'cnpj',
            header: 'CNPJ',
            size: 150
        },
        {
            accessorKey: 'name',
            header: 'Razão Social',
            size: 200
        },
        {
            accessorFn: (row) => `${row.customers[0].email}`,
            header: 'E-mail',
            size: 200
        },
        {
            accessorFn: (row) => row.plan_group_id ? `${row.plan_group_id}` : '-',
            accessorKey: 'plan_group_id',
            header: 'ID do Grupo de Plano'
        }
    ]

    const onCreate = () => {
        setOpenCreateModal(!openCreateModal)
    }

    const onUpdate = (row) => {
        dispatch(acGetAccessKey(row.original.application_access_key_id))
            .then(() => {
                setOpenUpdateModal(!openUpdateModal)
            })
            .catch(error => console.error(error))
    }

    return (
        <>
            <CreateAccessCredentialsModal
                open={openCreateModal}
                onClose={() => setOpenCreateModal(!openCreateModal)}
            />
            <UpdateAccessKeyModal
                open={openUpdateModal}
                onClose={() => setOpenUpdateModal(!openUpdateModal)}
                selectedAccessKey={selectedKey}
            />
            <DataTable
                resource='Cliente'
                gender='masc'
                tableType='createOnly'
                columns={columns}
                data={allCredentials}
                onCreate={onCreate}
                onUpdate={onUpdate}
                isLoading={isLoadingAllCredentials}
                isSaving={isCreatingKey || isUpdatingKey}
                showAlertBanner={hasErrorAllCredentials}
            />
        </>
    )

}

export default UserManagementTable